import { Injectable, Injector } from '@angular/core';
import { toBasicActions } from '@k2/common/state/batch-action';
import { Action, ActionsSubject, ReducerManager, StateObservable, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppStore<T> extends Store<T> {
  constructor(
    state$: StateObservable,
    private actions: ActionsSubject,
    reducerManager: ReducerManager
  ) {
    super(state$, actions, reducerManager);
  }

  override dispatch(action: any, config?: { injector: Injector }): any {
    if (typeof action === 'function') {
      return super.dispatch(action, config!);
    }
    const actions = toBasicActions(action);
    actions.forEach(a => super.dispatch(a));
  }

  dispatchWithResult(action: Action): Observable<any> {
    this.dispatch(action);

    return this.actions.pipe(
      first((next: ObservableActionResult) => next.source === action),
      timeout(30000),
      map((a: ObservableActionResult) => {
        if (a.type.endsWith('(SUCCESS)')) return a.payload;
        throw a.payload;
      })
    );
  }
}

export class ObservableActionResult implements Action {
  constructor(readonly type: string, readonly source: Action, readonly payload: any) {
  }

  static success(source: Action, payload: any) {
    return new ObservableActionResult(`${source.type} (SUCCESS)`, source, payload);
  }

  static failed(source: Action, payload: any) {
    return new ObservableActionResult(`${source.type} (FAILED)`, source, payload);
  }
}
